export { default } from './Grid';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Grid/index.js
// module id = 8
// module chunks = 2